/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetSBPPayloadQueryResponse, GetSBPPayloadQueryParams, GetSBPPayload400, GetSBPPayload401, GetSBPPayload404 } from "../entities/GetSBPPayload";

function getGetSBPPayloadUrl() {
  const res = { method: 'GET', url: `/api/v1/payments/sbp` as const }
  return res
}

/**
 * @description Получает payload для платежа через СБП. Платеж должен быть инициализирован через T-Bank.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - payment_id - идентификатор платежа в системе Т-Бизнес
 * **Процесс:**
 * 1. Валидация входных данных
 * 2. Проверка, что у пользователя есть аккаунт
 * 3. Получение payload для платежа через СБП
 * 4. Возврат payload для платежа через СБП
 * @summary Получение payload для платежа через СБП
 * {@link /api/v1/payments/sbp}
 */
export async function getSBPPayload(params: GetSBPPayloadQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetSBPPayloadQueryResponse, ResponseErrorConfig<GetSBPPayload400 | GetSBPPayload401 | GetSBPPayload404>, unknown>({ method : "GET", url : getGetSBPPayloadUrl().url.toString(), params, ... requestConfig })
  return res.data
}